<template>
  <div style="height: 100%!important;">
    <Header />
    <div class="modal modal-sorecom">
      <div class="modal-content" style="width:30%">
        <div class="modal-header">
          <p>Edit</p>
          <span class="close" @click="closeEdit">&times;</span>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <p>Qty SO</p>
            <input v-model="item.QtySO" type="number" class="form-control">
          </div>
          <div class="form-group">
            <p>+ / -</p>
            <input v-model="item.DistIncrease" type="number" class="form-control">
          </div>
          <div class="pb-4">
            <input type="checkbox" v-model="item.Prio">
            <label class="pl-2">Prioritas</label>
          </div>
          <div class="form-group">
            <p>Comment</p>
            <textarea v-model="item.DistComment" class="form-control"
              rows="3"></textarea>
          </div>
          <div>
            <button @click="saveEdit" type="button" class="btn btn-outline-primary">Save</button>
          </div>
        </div>

      </div>
      </div>
    <div class="row mt-3 pl-3 pr-3">
      <div class="col-4 text-left align-text-bottom align-bottom">
        <h3 class="heading-section h-100 align-bottom">SO Approval #{{$route.params.id}}</h3>
      </div>
      <div class="col-8 text-right">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Total M<sup>3</sup></th>
              <th scope="col">Total M<sup>3</sup> Recom</th>
              <th scope="col">Tambahan</th>
              <th scope="col">Pengurangan</th>
              <th scope="col">Prioritas</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <h3>
                  {{round(totalM3)}}
                </h3>
              </td>
              <td>
                <h3>
                  {{round(totalRecomM3)}}
                </h3>
              </td>
              <td>
                <h3>
                  {{round(totalIncreaseM3)}}
                </h3>
              </td>
              <td>
                <h3>
                  {{round(totalDecreaseM3)}}
                </h3>
              </td>
              <td>
                <h3>
                  {{totalPrioritas}}
                </h3>
              </td>
            </tr>
          </tbody>
        </table>
         <!-- <h3> <small> Total Volume :</small> {{round(totalM3)}} + increase {{round(totalIncreaseM3)}} + decrease {{round(totalDecreaseM3)}}</h3> -->
      </div>
    </div>
    <br>
     <div v-if="IsLoading" class="spinner-border" style="position:fixed; top:50%; left:50%" role="status">
            <span class="sr-only">Loading...</span>
    </div>
    <span v-else>
    <div class="table-wrap tableFixHead pl-3 pr-3">
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="text-right">#</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>UOM</th>
            <th class="text-right">Qty. Dist.</th>
            <th class="text-right">Qty. In Transit</th>
            <th class="text-right">Qty. Total</th>
            <th class="text-right">Qty Recom</th>
            <th class="text-right">Qty SO</th>
            <th class="text-right">Dist. +/-</th>
            <th class="text-right">M<sup>3</sup></th>
            <th>Dist. Comment</th>
            <th class="text-center">Prioritas</th>
            <th class="text-center">Lock</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, i) in recommended" :key="item.DocID">
            <tr @dblclick="()=>openEdit(item)" :style="item.QtyRecom === 0? {backgroundColor: 'yellow!important'}: {}">
              <th class="text-right">{{i+1}}.</th>
              <th>{{item['Item Code']}}</th>
              <td>{{item['Item Name']}}</td>
              <td>{{item.UOM}}</td>
              <td class="text-right">{{roundDown(item.QtyStockDist)}}</td>
              <td class="text-right">{{roundDown(item.QtyStockInTransit)}}</td>
              <td class="text-right">{{roundDown(item.QtyStockInTransit) + roundDown(item.QtyStockDist)}}</td>
              <td class="text-right">{{item.QtyRecom}}</td>
              <td class="text-right">{{item.QtySO}}</td>
              <td class="text-right">{{item.DistIncrease}}</td>
              <td class="text-right">{{round(item.UnitM3)}}</td>
              <td>{{item.DistComment}}</td>
              <td class="text-center justify-center">
                <svg v-if="item.Prio == 0" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13px" height="13px"
                  viewBox="0 0 459 459" style="enable-background:new 0 0 459 459;" xml:space="preserve"
                  fill="grey"
                  >
                  <g id="check-box-outline-blank">
                    <path d="M408,51v357H51V51H408 M408,0H51C22.95,0,0,22.95,0,51v357c0,28.05,22.95,51,51,51h357c28.05,0,51-22.95,51-51V51
  C459,22.95,436.05,0,408,0L408,0z" />
                  </g>
                </svg>
                <svg v-else fill="green" height="13px" viewBox="0 0 512 512" width="13px" xmlns="http://www.w3.org/2000/svg"><path d="m452 512h-392c-33.085938 0-60-26.914062-60-60v-392c0-33.085938 26.914062-60 60-60h392c33.085938 0 60 26.914062 60 60v392c0 33.085938-26.914062 60-60 60zm-392-472c-11.027344 0-20 8.972656-20 20v392c0 11.027344 8.972656 20 20 20h392c11.027344 0 20-8.972656 20-20v-392c0-11.027344-8.972656-20-20-20zm370.898438 111.34375-29.800782-26.6875-184.964844 206.566406-107.351562-102.046875-27.558594 28.988281 137.21875 130.445313zm0 0"/></svg>
              </td>
              <td class="text-center">
                <button v-if="item.Lock">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-file-lock" viewBox="0 0 16 16">
                    <path
                      d="M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224zM6.105 8.125A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3c0-.042.02-.107.105-.175z" />
                    <path
                      d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                  </svg>
                </button>
                <button v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-pencil-square" viewBox="0 0 16 16">
                    <path
                      d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path fill-rule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                  </svg>
                </button>
              </td>
            </tr>
          </template>
          <tr style="height:30px" @click="()=> { expanded = !expanded}">
            <td>
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="!expanded">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 13l-7 7-7-7m14-8l-7 7-7-7" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" v-if="expanded">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11l7-7 7 7M5 19l7-7 7 7" />
                </svg>
              </div>
            </td>
            <th>SHOW ALL</th>
            <td colspan="14"></td>
          </tr>
          <template v-for="(item, i) in notRecommended" :key="item.DocID" >
            <tr v-if="expanded" @dblclick="()=>openEdit(item)" :style="item.QtyRecom === 0? {backgroundColor: '#FFFFF0!important'}: {}">
              <th class="text-right">{{recommended.length+i+1}}.</th>
              <th>{{item['Item Code']}}</th>
              <td>{{item['Item Name']}}</td>
              <td>{{item.UOM}}</td>
              <td class="text-right">{{roundDown(item.QtyStockDist)}}</td>
              <td class="text-right">{{roundDown(item.QtyStockInTransit)}}</td>
              <td class="text-right">{{roundDown(item.QtyStockInTransit) + roundDown(item.QtyStockDist)}}</td>
              <td class="text-right">{{item.QtyRecom}}</td>
              <td class="text-right">{{item.QtySO}}</td>
              <td class="text-right">{{item.DistIncrease}}</td>
              <td class="text-right">{{round(item.UnitM3)}}</td>
              <td>{{item.DistComment}}</td>
              <td class="text-center justify-center">
                <svg v-if="item.Prio == 0" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13px" height="13px"
                     viewBox="0 0 459 459" style="enable-background:new 0 0 459 459;" xml:space="preserve"
                     fill="grey"
                >
                  <g id="check-box-outline-blank">
                    <path d="M408,51v357H51V51H408 M408,0H51C22.95,0,0,22.95,0,51v357c0,28.05,22.95,51,51,51h357c28.05,0,51-22.95,51-51V51
  C459,22.95,436.05,0,408,0L408,0z" />
                  </g>
                </svg>
                <svg v-else fill="green" height="13px" viewBox="0 0 512 512" width="13px" xmlns="http://www.w3.org/2000/svg"><path d="m452 512h-392c-33.085938 0-60-26.914062-60-60v-392c0-33.085938 26.914062-60 60-60h392c33.085938 0 60 26.914062 60 60v392c0 33.085938-26.914062 60-60 60zm-392-472c-11.027344 0-20 8.972656-20 20v392c0 11.027344 8.972656 20 20 20h392c11.027344 0 20-8.972656 20-20v-392c0-11.027344-8.972656-20-20-20zm370.898438 111.34375-29.800782-26.6875-184.964844 206.566406-107.351562-102.046875-27.558594 28.988281 137.21875 130.445313zm0 0"/></svg>
              </td>
              <td class="text-center">
                <button v-if="item.Lock">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-file-lock" viewBox="0 0 16 16">
                    <path
                        d="M8 5a1 1 0 0 1 1 1v1H7V6a1 1 0 0 1 1-1zm2 2.076V6a2 2 0 1 0-4 0v1.076c-.54.166-1 .597-1 1.224v2.4c0 .816.781 1.3 1.5 1.3h3c.719 0 1.5-.484 1.5-1.3V8.3c0-.627-.46-1.058-1-1.224zM6.105 8.125A.637.637 0 0 1 6.5 8h3a.64.64 0 0 1 .395.125c.085.068.105.133.105.175v2.4c0 .042-.02.107-.105.175A.637.637 0 0 1 9.5 11h-3a.637.637 0 0 1-.395-.125C6.02 10.807 6 10.742 6 10.7V8.3c0-.042.02-.107.105-.175z" />
                    <path
                        d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                  </svg>
                </button>
                <button v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                       class="bi bi-pencil-square" viewBox="0 0 16 16">
                    <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                  </svg>
                </button>
              </td>
            </tr>
          </template>

        </tbody>
      </table>
    </div>
    <br>
    <div class="d-flex flex-row mt-2 bg-gray-50 p-1">
      <div class="col-sm-5 col-md-6">
         <p>
          Comment
        </p>
          <textarea v-model="comment" class="form-control" rows="2"></textarea>
      </div>
      <div class="d-flex flex-row align-items-center">
        <div>
          <input type="checkbox" name="terms and conditions" v-model="tac">
        </div>
        <div class="ml-2">
          I agree to the Terms and Conditions
        </div>
      </div>
      <div class="d-flex flex-grow-1 justify-content-end">
         <!-- <button :disabled="!tac || !(totalDecreaseM3 <= 2) || !(totalIncreaseM3 >= 2) || !(totalPrioritas > 0)" class="btn btn-primary" style="width: 300px; height: 100px;" @click="submit">Submit</button> -->
         <button :disabled="!tac" class="btn btn-primary" style="width: 300px; height: 90px;" @click="submit">Submit</button>
      </div>
    </div>
    </span>
  </div>
</template>
<style>
.tableFixHead          { overflow: auto; height: 65%; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; }
  th,
  td {
    white-space: nowrap;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2 !important;
  }
  body {
    line-height: 0 !important;
  }
  p {
    line-height: 10px !important;
  }
  .table thead th {
    padding: 10px !important;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .table tbody td,
  .table tbody th {
    border: none;
    padding: 10px !important;
    font-size: 14px;
    vertical-align: middle;
  }

  tr {
    padding: 0 !important;
    margin: 0 !important;
  }
  /* The Modal (background) */
  .modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    padding-top: 10%;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
  }

  /* Modal Content */
  .modal-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    border: 1px solid #888;
    width: 80%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }
  /* Add Animation */
  @-webkit-keyframes animatetop {
    from {
      top: -300px;
      opacity: 0
    }

    to {
      top: 0;
      opacity: 1
    }
  }

  @keyframes animatetop {
    from {
      top: -300px;
      opacity: 0
    }

    to {
      top: 0;
      opacity: 1
    }
  }
  /* The Close Button */
  .close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  .modal-header {
    background-color: whitesmoke;
    color: white;
    height: 40px;
  }

  .modal-body {
    padding: 2px 16px;
  }
</style>
<script lang="ts" src="./SORecomDetail.ts"></script>